import { SET_NEWS, SET_NEWS_CATEGORIES, SET_NEWS_LOADING, SET_MORE_NEWS_AVAILABLE } from '../types'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_NEWS:
      return {
        ...state,
        news: action.payload,
        newsLoaded: true,
        newsLoading: false,
      }
    case SET_NEWS_CATEGORIES:
      return {
        ...state,
        newsCategories: action.payload,
        newsCategoriesLoaded: true,
      }
    case SET_MORE_NEWS_AVAILABLE:
      return {
        ...state,
        moreNewsAvailable: action.payload,
      }
    case SET_NEWS_LOADING:
      return {
        ...state,
        newsLoading: action.payload,
      }
    default:
      return state
  }
}

export default reducer
